import _ from 'lodash';
import moment from 'moment';

import React, { Component } from 'react';
import { connect } from 'react-redux';

import { CopyToClipboard } from 'react-copy-to-clipboard';

import {
  Firebase,
  getOptionValueForSelect,
  localizeToString,
  getIcon,
  formatThousands,
  unwrapDocs,
} from '../../util';

import { DateRangePicker } from 'react-dates';

import Select from 'react-select';

class AssessmentsPage extends Component {

  state = {
    assessments: null,
    assessmentConfig: null,
    showingMoreFilters: false,
    filters: {
      completedOnMin: null,
      completedOnMax: null,
      status: null
    },
    search: '',
    sortByColumn: 'completedOn',
    sortDesc: true,
    showingAllPastExports: false,
    exportQueued: false,
    focusedDatePicker: null,
    confirmingAssessmentStatusChange: false,
    recentlyCopied: false,
  }

  renderShowFilters(){
    if(this.state.showingMoreFilters){
      return null;
    }
    return (
      <div
        onClick={() => { this.setState({ showingMoreFilters: true }); }}
        className="show-filters">More filters</div>
    );
  }

  resultsAsCSV(){
    const firstRowForCSV = 'Email,Name,Status,Started,Completed';

    return _.reduce(this.filteredAssessments(), (memo, assessment) => {
      return memo + `\r${assessment.email},${assessment.user},${assessment.status},${assessment.startedOn ? moment(assessment.startedOn).format('M/D/YY') : ''},${assessment.completedOn ? moment(assessment.completedOn).format('M/D/YY') : ''}`;
    }, firstRowForCSV);
  }

  updateFilterValue(key, newValue){
    this.setState({
      filters: {
        ...this.state.filters,
        [key]: newValue
      }
    });
  }

  activeColumns(){

    /*
    <div className="row-item row-item-heading sortable">Profile</div>
    <div className="row-item row-item-heading sortable">Name</div>
    <div className="row-item row-item-heading sortable" style={{flex: 2}}>Email</div>
    <div className="row-item row-item-heading sortable">Started</div>
    <div className="row-item row-item-heading sortable">Completed</div>
    <div className="row-item row-item-heading sortable">&nbsp;</div>
    */

    return [{
      id: 'profileName',
      label: 'Profile',
      render: (item) => {
        return item.profileName
      },
      sort: 'profileName'
    },{
      id: 'user',
      label: 'Name',
      render: (item) => {
        return item.user;
      },
      sort: 'user'
    },{
      id: 'email',
      label: 'Email',
      styles: { flex: 2 },
      render: (item) => {
        return item.email
      },
      sort: 'email'
    },{
      id: 'startedOn',
      label: 'Started',
      render: (item) => {
        if(item.startedOn){
          return moment(item.startedOn).format('M/D/YY');
        }
        else{
          return '';
        }
      },
      sort: 'startedOn'
    },{
      id: 'completedOn',
      label: 'Completed',
      render: (item) => {
        if(item.completedOn){
          return moment(item.completedOn).format('M/D/YY');
        }
        else{
          return '';
        }
      },
      sort: 'completedOn'
    },{
      id: 'actions',
      label: '',
      render: (item) => {
        if(item.playbookDownloadUrl){
          return <a href={item.playbookDownloadUrl} target="_blank">View Playbook</a>
        }
        else{
          return '';
        }
      },
    }];
  }

  updateSortBy(columnId){

    const { sortDesc, sortByColumn } = this.state;
    const isSortingOnColumn = columnId === sortByColumn;

    if(isSortingOnColumn){
      this.setState({
        sortDesc: !sortDesc
      });
    }
    else{
      this.setState({
        sortByColumn: columnId
      });
    }
  }

  renderColumn(column){

    const { sortDesc, sortByColumn } = this.state;
    const isSortingOnColumn = column.id === sortByColumn;

    return (
      <div
        onClick={() => { this.updateSortBy(column.id); }}
        key={column.id}
        className={`row-item row-item-heading ${column.sort ? 'sortable' : ''} ${isSortingOnColumn ? 'is-sorting ' : ''}`} style={column.styles || {}}>{column.label}<span className={`sort-toggle ${sortDesc ? 'sort-direction-desc' : ''}`}>{getIcon('sort')}</span></div>
    )
  }

  renderActiveColumns(){
    const activeColumns = this.activeColumns();

    return (
      <div className="sortable-list-row headings">
        {_.map(activeColumns, this.renderColumn.bind(this))}
      </div>
    )
  }

  renderAssessmentStatusFilter(){
    const statusOptions = [
      {
        label: 'All statuses',
        value: null
      },
      {
        label: 'In Progress',
        value: 'inprogress'
      },
      {
        label: 'Completed',
        value: 'scored'
      }
    ];

    const { status } = this.state.filters;

    return (
      <Select
        classNamePrefix={'react-select'}
        className={`react-select-container small-select ${status ? 'has-value' : ''}`}
        value={getOptionValueForSelect(statusOptions, status)}
        options={statusOptions}
        onChange={(option) => { this.updateFilterValue('status', option.value); } }
      />
    )
  }

  updatedCompletedDateFilter(startDate, endDate){
    this.setState({
      filters: {
        ...this.state.filters,
        completedOnMin: startDate,
        completedOnMax: endDate
      }
    });
  }

  renderCompletedOnDateFilter(){

    const {
      completedOnMin,
      completedOnMax,
    } = this.state.filters;

    return (
      <div className="completed-on-filter">
        <div className="label">Completed<br/>Between</div>
        <DateRangePicker
          startDatePlaceholderText="Start"
          endDatePlaceholderText="End"
          startDate={completedOnMin}
          startDateId="completed-on-start-date"
          endDate={completedOnMax}
          endDateId="completed-on-end-date"
          onDatesChange={({startDate, endDate}) => { this.updatedCompletedDateFilter(startDate, endDate); } }
          focusedInput={this.state.focusedDatePicker}
          onFocusChange={focusedDatePicker => { this.setState({ focusedDatePicker }); }}
          isOutsideRange={() => { return false; } }
        />
      </div>
    )
  }

  renderMoreFilters(){
    return (
      <div className="select-group" style={{margin: 5}}>
        {this.renderAssessmentStatusFilter()}
        {this.renderCompletedOnDateFilter()}
      </div>
    )
  }

  mapAssessmentItem(assessment){
    const mappedAssessment = _.cloneDeep(assessment);

    mappedAssessment.profileName = localizeToString(this.props.activeLocalization, `talent_profile_${assessment.profile}_label`);
    mappedAssessment.searchString = `${assessment.user} ${assessment.email} ${assessment.profileName} ${mappedAssessment.profileName}`.toLowerCase();

    return mappedAssessment;
  }

  getAssessments(){
    const callable = Firebase.functions().httpsCallable('getOrganizationAssessments');

    callable({  }).then(result => {
      console.log('fetched assessments: ', result.data);
      this.setState({
        assessments: _.map(result.data, this.mapAssessmentItem.bind(this))
      });
    }).catch(err => {
      console.error('error fetching assessments: ', err);
    });
  }

  componentWillMount(){
    this.getAssessments();
    this.fetchAssessmentConfigForOrganization();
  }

  renderAssessmentItem(assessmentItem){

    const {
      user,
      _id,
      status,
      profile,
      email,
      startedOn,
      completedOn,
      playbookDownloadUrl,
      profileName,
    } = assessmentItem;

    //const userFriendlyStatus = (status === 'inprogress' ? `In Progress` : 'Complete');

    return (
      <div key={_id} className="sortable-list-row">
        <div className="row-item">{profileName}</div>
        <div className="row-item">{user}</div>
        <div className="row-item" style={{flex: 2}}>
          <a href={`mailto:${email}`} target="_blank">{email}</a>
        </div>
        <div className="row-item">{startedOn ? moment(startedOn).format('MM/DD/YY') : ''}</div>
        <div className="row-item">{completedOn ? moment(completedOn).format('MM/DD/YY') : 'Incomplete'}</div>
        {playbookDownloadUrl &&
          <div className="row-item">
            <a href={playbookDownloadUrl} target="_blank">View Playbook</a>
          </div>
        }
      </div>
    )
  }

  renderReportRowItem(column, item){
    return (
      <div key={`item-${item._id}-row-item-for-column-${column.id}`} className={`row-item row-status-${item.status}`} style={column.styles || {}}>{column.render(item)}</div>
    )
  }

  renderReportRow(deal){
    return (
      <div key={`row-for-deal-${deal._id}`} className="sortable-list-row">
        {_.map(this.activeColumns(), column => { return this.renderReportRowItem(column, deal); })}
      </div>
    )
  }

  filteredAssessments(){
    const {
      assessments,
      search,
      filters,
      sortByColumn,
      sortDesc,
    } = this.state;

    let filteredAndSearchedAssessments = _.cloneDeep(assessments);

    if(search && search !== ''){
      const lcSearchString = search.toLowerCase();
      filteredAndSearchedAssessments = _.filter(filteredAndSearchedAssessments, assessment => {
        return assessment.searchString.indexOf(lcSearchString) !== -1;
      });
    }

    if(filters.status){
      filteredAndSearchedAssessments = _.filter(filteredAndSearchedAssessments, assessment => {
        return assessment.status === filters.status;
      });
    }

    if(filters.completedOnMin){
      filteredAndSearchedAssessments = _.filter(filteredAndSearchedAssessments, assessment => {
        return assessment.completedOn && filters.completedOnMin.diff(assessment.completedOn) < 0;
      });
    }

    if(filters.completedOnMax){
      filteredAndSearchedAssessments = _.filter(filteredAndSearchedAssessments, assessment => {
        return assessment.completedOn && filters.completedOnMax.diff(assessment.completedOn) > 0;
      });
    }

    const sortByColumnData = _.find(this.activeColumns(), { id: sortByColumn });
    const sortByFunction = sortByColumnData.sort;

    const sortedData = _.sortBy(filteredAndSearchedAssessments, sortByFunction);

    if(sortDesc){ sortedData.reverse(); }

    return sortedData;
  }

  resetFilters(){
    this.setState({
      search: '',
      filters: {
        completedOnMin: null,
        completedOnMax: null,
        status: null
      }
    });
  }

  loadingAssessments(){
    return this.state.assessments === null;
  }

  renderAssessmentsList(){

    const filteredAssessments = this.filteredAssessments();
    const loadingAssessments = this.loadingAssessments()

    if(_.size(filteredAssessments) === 0){
      return (
        <div className="sortable-list-view">
          {loadingAssessments &&
            <div className="sortable-list-no-rows-message">
              <p>Loading assessments...</p>
            </div>
          }
          {!loadingAssessments &&
            <div className="sortable-list-no-rows-message">
              <p>No assessments match filters</p>
              <p><small onClick={this.resetFilters.bind(this)} className="actionable">Reset filters</small></p>
            </div>
          }
        </div>
      )
    }

    return (
      <div className="assessments-list">
        <div className="sortable-list-view">
          {this.renderActiveColumns()}
          {_.map(this.filteredAssessments(), this.renderReportRow.bind(this))}
        </div>
      </div>
    )
  }

  orgName(){
    return (this.props.organization || {}).name;
  }

  renderAssessmentSearch(){

    const { search } = this.state;

    return (
      <input className="assessment-search" type="text" value={search} onChange={e => { this.setState({ search: e.target.value }); }} placeholder="Search..." />
    )
  }

  queuePlaybookExport(exportType){
    const callable = Firebase.functions().httpsCallable('queueExportOfPlaybooks');

    if(this.state.exportQueued){
      return;
    }

    this.setState({
      exportQueued: exportType
    });

    let assessmentSubmissionIds = null;

    if(exportType === 'visible'){
      assessmentSubmissionIds = _.map(_.filter(this.filteredAssessments(), { status: 'scored' }), '_id');
    }

    callable({ ...(assessmentSubmissionIds && { assessmentSubmissionIds })}).then(result => {
      console.log('batch download prepared!!!!: ', result.data);
      this.setState({
        queuedExportIsVisible: true
      });
    }).catch(err => {
      console.error('error queueing batch download: ', err);
    });
  }

  renderExportItem(item){

    if(item.downloadUrl){
      return (
        <a key={item._id} href={item.downloadUrl} target="_blank">
          <li className="export-item">{getIcon('export')} {moment(item.createdOn.toDate()).format('M/D/YY h:mmA')}{this.state.exportQueued ? <small><br/>Click to download</small> : ''}<br/><small>{formatThousands(item.meta.size, 1)}MB / {item.meta.count} playbook{item.meta.count !== 1 ? 's' : ''}</small></li>
        </a>
      )
    }
    else{
      return (
        <li key={item._id} className="export-item">{getIcon('export')} {moment(item.createdOn.toDate()).format('M/D/YY h:mmA')}<br/><small>Preparing...</small></li>
      )
    }

  }

  renderPastExportsList(){
    const { organizationExports } = this.props;
    const { showingAllPastExports } = this.state;

    const showingExports = _.take(_.sortBy(organizationExports, 'createdOn').reverse(), (showingAllPastExports ? 10000 : 1));

    return (
      <div className="exports-list">
        <p>{showingAllPastExports ? 'All past exports:' : 'Most recent export:'}</p>
        <ul>
          {_.map(showingExports, this.renderExportItem.bind(this))}
        </ul>
        {!showingAllPastExports && _.size(organizationExports) > 1 &&
          <p onClick={() => { this.setState({ showingAllPastExports: true }); }} className="show-all">Show all past exports</p>
        }
      </div>
    )
  }

  renderExportsFooter(){

    const {
      queuedExportIsVisible,
      exportQueued,
      recentlyCopied,
    } = this.state;

    const loadingAssessments = this.loadingAssessments();
    const assessmentsAreFiltered = _.size(this.filteredAssessments()) < _.size(this.state.assessments);
    const filteredCompletedPlaybooksSize = _.size(_.filter(this.filteredAssessments(), { status: 'scored' }));

    if(loadingAssessments){
      return;
    }

    return (
      <div className="page-footer">
        <div className="centered-action">
          {!queuedExportIsVisible && filteredCompletedPlaybooksSize > 0 &&
            <React.Fragment>
              {exportQueued !== 'all' && assessmentsAreFiltered &&
                <button disabled={exportQueued} onClick={() => { this.queuePlaybookExport('visible') }} className="button grey-button">{exportQueued ? 'Preparing Download...' : `Download ${filteredCompletedPlaybooksSize} Filtered Playbook${filteredCompletedPlaybooksSize !== 1 ? 's' : ''}`}</button>
              }
              {exportQueued !== 'visible' &&
                <button disabled={exportQueued} onClick={() => { this.queuePlaybookExport('all') }} className="button grey-button">{exportQueued ? 'Preparing Download...' : 'Download All Playbooks'}</button>
              }
              <CopyToClipboard options={{format: "text/plain"}} text={this.resultsAsCSV()} onCopy={() => { this.setState({ recentlyCopied: true }); setTimeout(() => { this.setState({ recentlyCopied: false }); }, 1000); }}>
                <button className="button grey-button">{recentlyCopied ? 'Copied!' : `Copy${assessmentsAreFiltered ? ' Filtered Results' : ''} to CSV`}</button>
              </CopyToClipboard>
            </React.Fragment>
          }
        </div>
        {this.renderPastExportsList()}
      </div>
    )
  }

  toggleAssessmentStatus(){
    const {
      confirmingAssessmentStatusChange
    } = this.state;

    if(confirmingAssessmentStatusChange){
      const callable = Firebase.functions().httpsCallable('toggleAssessmentConfigOpenStatus');

      this.setState({
        assessmentConfig: null
      });

      callable({  }).then(result => {
        this.fetchAssessmentConfigForOrganization();
        this.setState({
          confirmingAssessmentStatusChange: false
        });

      }).catch(err => {
        console.error('error toggling end date (open/close status): ', err);
      });
    }
    else{
      this.setState({
        confirmingAssessmentStatusChange: true
      });
    }
  }

  fetchAssessmentConfigForOrganization(){
    if(!this.props.organization){
      return;
    }

    Firebase.firestore().collection(`assessmentConfigs`).get().then(docs => {
      const configs = unwrapDocs(docs);

      const configForOrg = _.find(configs, config => {
        return config.organization === this.props.organization._id;
      });

      console.log('configForOrg: ', configForOrg);

      this.setState({
        assessmentConfig: configForOrg
      });
    });
  }

  componentDidUpdate(prevProps){
    if(!prevProps.organization && this.props.organization){
      this.fetchAssessmentConfigForOrganization();
    }
  }

  renderAssessmentConfigBanner(){

    const {
      confirmingAssessmentStatusChange,
      assessmentConfig,
    } = this.state;

    if(!assessmentConfig){
      return null;
    }

    console.log('assessmentConfig.endDate: ', assessmentConfig.endDate);

    if(assessmentConfig.endDate){
      if(moment(assessmentConfig.endDate.toDate()).diff(moment()) > 0){
        return (
          <div className="page-banner">
            <p>Assessments are set to close as of {moment(assessmentConfig.endDate.toDate()).format('MM/DD/YY @ HH:mm:ss (Z)')}</p>
            <button onClick={() => { this.toggleAssessmentStatus(); }}>{confirmingAssessmentStatusChange ? 'Confirm changes?' : 'Click to remove end date'}</button>
          </div>
        )
      }
      else{
        return (
          <div className="page-banner">
            <p>Assessments are currently closed as of {moment(assessmentConfig.endDate.toDate()).format('MM/DD/YY @ HH:mm:ss (Z)')}</p>
            <button onClick={() => { this.toggleAssessmentStatus(); }}>{confirmingAssessmentStatusChange ? 'Confirm changes?' : 'Click to open assessment'}</button>
          </div>
        )
      }
    }
    else{
      return (
        <div className="page-banner">
          <p>Assessments are currently open</p>
          <button onClick={() => { this.toggleAssessmentStatus(); }}>{confirmingAssessmentStatusChange ? 'Confirm changes? ANY IN-PROGRESS ASSESSMENTS WILL BE INACCESSIBLE!' : `Click to close assessment`}</button>
        </div>
      )
    }
  }

  completeCount(){
    return _.size(_.filter(this.state.assessments || [], { status: 'scored' }));
  }
  inProgressCount(){
    return _.size(_.filter(this.state.assessments || [], { status: 'inprogress' }));
  }

  render(){

    return (
      <div className="page assessments">
        {this.renderAssessmentConfigBanner()}
        <div className="page-main-content">
          <div className="page-title">
            <h1>{this.orgName()} Assessments</h1>
            <h3>{this.completeCount()} Complete, {this.inProgressCount()} In Progress</h3>
          </div>
          <div className="page-actions">
            <div className="select-group">
              {this.renderAssessmentSearch()}
              {this.renderShowFilters()}
              {this.state.showingMoreFilters && this.renderMoreFilters()}
            </div>
          </div>
          <div className="page-content">
            {this.renderAssessmentsList()}
          </div>
        </div>
        {this.renderExportsFooter()}
      </div>
    )
  }
}

function mapStateToProps(state, ownProps){
  return {
    organization: state.organization.data,
    activeLocalization: state.activeLocalization.data,
    organizationExports: state.organizationExports.data,
  }
}

export default connect(mapStateToProps, {})(AssessmentsPage);



// WEBPACK FOOTER //
// ./src/components/assessments/index.js